module.exports = __webpack_public_path__ + "../panel-assets/img/promotion-slot-img.1ed325d7.png";